// extracted by mini-css-extract-plugin
module.exports = {"historyTable":"EntityView_historyTable__389qv","faqText":"EntityView_faqText__M6B7J"};